// @mui icons
import FacebookIcon from "@mui/icons-material/Facebook";
import TwitterIcon from "@mui/icons-material/Twitter";
import YouTubeIcon from "@mui/icons-material/YouTube";

// React components
import CustomTypography from "components/CustomTypography";

// Images
import logoCT from "assets/images/logo-ct-dark.png";

const date = new Date().getFullYear();

export default {
  brand: {
    name: "ctrl-ai-delete",
    image: logoCT,
    route: "/",
  },
  socials: [
    {
      icon: <FacebookIcon />,
      link: "https://www.facebook.com",
    },
    {
      icon: <TwitterIcon />,
      link: "https://www.twitter.com",
    },
    {
      icon: <YouTubeIcon />,
      link: "https://www.youtube.com",
    },
  ],
  menus: [
    {
      name: "company",
      items: [
        { name: "about us", href: "" },
        { name: "blog", href: "" },
      ],
    },
    {
      name: "pricing",
      items: [{ name: "pricing", href: "" }],
    },
    {
      name: "help & support",
      items: [
        { name: "contact us", href: "" },
        { name: "knowledge center", href: "" },
        { name: "custom development", href: "" },
      ],
    },
    {
      name: "legal",
      items: [
        { name: "terms & conditions", href: "" },
        { name: "privacy policy", href: "" },
        { name: "licenses (EULA)", href: "" },
      ],
    },
  ],
  copyright: (
    <CustomTypography variant="button" fontWeight="regular">
      All rights reserved. Copyright &copy; {date} ctrl-ai-delete.
      <CustomTypography
        component="a"
        href="https://www.google.com"
        target="_blank"
        rel="noreferrer"
        variant="button"
        fontWeight="regular"
      />
    </CustomTypography>
  ),
};
